import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupItemTemplateCategoriesApi = {
    getTrialGroupItemTemplateCategories: (): Observable<Dtos.GetTrialGroupItemTemplateCategoriesResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupItemTemplateCategories = new Dtos.GetTrialGroupItemTemplateCategories();

        //Send request.
        const response: Promise<Dtos.GetTrialGroupItemTemplateCategoriesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupItemTemplateCategoryById: (id: number): Observable<Dtos.GetTrialGroupItemTemplateCategoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupItemTemplateCategoryById = new Dtos.GetTrialGroupItemTemplateCategoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupItemTemplateCategoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupItemTemplateCategory: (trialGroupItemTemplateCategory: Dtos.TrialGroupItemTemplateCategory): Observable<Dtos.SetTrialGroupItemTemplateCategoryResponse> => {

        let request: Dtos.SetTrialGroupItemTemplateCategory = new Dtos.SetTrialGroupItemTemplateCategory();

        request.trialGroupItemTemplateCategory = trialGroupItemTemplateCategory;

        // send request
        const response: Promise<Dtos.SetTrialGroupItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialGroupItemTemplateCategory: (): Observable<Dtos.CreateTrialGroupItemTemplateCategoryResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupItemTemplateCategory = new Dtos.CreateTrialGroupItemTemplateCategory();

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupItemTemplateCategoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialGroupItemTemplateCategory: (trialGroupItemTemplateCategory: Dtos.TrialGroupItemTemplateCategory): Observable<Dtos.ValidateTrialGroupItemTemplateCategoryResponse> => {

        let request: Dtos.ValidateTrialGroupItemTemplateCategory = new Dtos.ValidateTrialGroupItemTemplateCategory();

        request.trialGroupItemTemplateCategory = trialGroupItemTemplateCategory;

        // send request
        const response: Promise<Dtos.ValidateTrialGroupItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    }
}